import { Breadcrumb, Layout } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import { apiGet, urls } from 'api'
import { CardContainer, FormDropDown, FormInput, Loading, Table } from 'components'
import { metaInitialData, perPageInitialData } from 'constant'
import { Formik } from 'formik'
import { useState } from 'react'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { logout } from 'store/actions'

const AnalyticsTotalInspektorPage = () => {
  const user = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const router = useHistory()
  const [currentPage, setCurrentPage] = useState(0)
  const [meta, setMeta] = useState(metaInitialData)
  const [perPageArr, setPerPageArr] = useState(perPageInitialData)
  const [listTotalInspektor, setListTotalInspektor] = useState([])
  const [dropDownBengkel, setDropDownBengkel] = useState([])
  const onLogout = () => dispatch(logout())

  const { isLoading, refetch } = useQuery({
    queryKey: ['analytic-cabang-total-inspektor-list'],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await Promise.all([
        apiGet({
          url: `${urls.analytic.prefixUser}/${urls.analytic.cabang.inspectorTotalList}?limit=${
            perPageArr.find((item) => item.selected === true).value
          }&offset=${meta.offset ?? 0}`,
          token: user.token,
          onLogout
        }),
        apiGet({
          url: `${urls.master.prefix}/${urls.master.workshops.all}`,
          token: user.token,
          onLogout
        })
      ]),
    onSuccess: (data) => {
      setListTotalInspektor(data[0].resData.data)
      setMeta(data[0].resData.meta)
      setDropDownBengkel([])
      if (data[1].resStatus === 200) {
        if (data[1].resData.data.length !== 0) {
          data[1].resData.data.map((item) => {
            setDropDownBengkel((prev) => [...prev, { name: item.name, value: item.id }])
          })
        }
      }
    }
  })

  const [isLoadingHelper, setIsLoadingHelper] = useState(false)
  const [bengkelSelected, setBengkelSelected] = useState()
  const [inspektorSearch, setInspektorSearch] = useState('')

  const onHandleExtraUrl = () => {
    let extraUrl = ''

    if (bengkelSelected && parseInt(bengkelSelected) > -1) {
      extraUrl += `&workshop_id=${parseInt(bengkelSelected)}`
    }
    if (inspektorSearch && inspektorSearch !== '') {
      extraUrl += `&keywords=${inspektorSearch}`
    }

    return extraUrl
  }

  const onFilterSearchListInspektor = async (bengkel, search) => {
    let extraUrl = ''
    if (bengkel && bengkel !== -1) {
      extraUrl += `&workshop_id=${bengkel}`
    }
    if (search && search !== '') {
      extraUrl += `&keywords=${search}`
    }
    const response = await apiGet({
      url: `${urls.analytic.prefixUser}/${urls.analytic.cabang.inspectorTotalList}?limit=${
        perPageArr.find((item) => item.selected === true).value
      }&offset=${meta.offset ?? 0}${extraUrl}`,
      token: user.token,
      onLogout
    })
    if (response.resStatus === 200 && response.resData.meta.http_code === 200) {
      setListTotalInspektor(response.resData.data)
      setMeta(response.resData.meta)
    } else {
      refetch()
    }
  }

  const onChangePrevNextPage = (offset) => {
    setIsLoadingHelper(true)
    setMeta({ ...meta, offset })
    const mount = setTimeout(async () => {
      const response = await apiGet({
        url: `${urls.analytic.prefixUser}/${urls.analytic.cabang.inspectorTotalList}?limit=${
          perPageArr.find((item) => item.selected === true).value
        }&offset=${offset}${onHandleExtraUrl()}`,
        token: user.token,
        onLogout
      })
      if (response.resStatus === 200 && response.resData.meta.http_code === 200) {
        setListTotalInspektor(response.resData.data)
      } else {
        refetch()
      }
      setIsLoadingHelper(false)
    })
    return () => clearTimeout(mount)
  }

  const onChangePerPage = (value) => {
    setIsLoadingHelper(true)
    const newArr = [...perPageArr]
    newArr.map((item) => {
      if (item.value === value) {
        item.selected = true
      } else {
        item.selected = false
      }
    })
    const mount = setTimeout(async () => {
      const response = await apiGet({
        url: `${urls.analytic.prefixUser}/${
          urls.analytic.cabang.inspectorTotalList
        }?limit=${value}&offset=${meta.offset ?? 0}${onHandleExtraUrl()}`,
        token: user.token,
        onLogout
      })
      if (response.resStatus === 200 && response.resData.meta.http_code === 200) {
        setListTotalInspektor(response.resData.data)
        setMeta(response.resData.meta)
        setPerPageArr(newArr)
      } else {
        refetch()
      }
      setIsLoadingHelper(false)
    })
    return () => clearTimeout(mount)
  }

  const columns = [
    {
      name: 'ID',
      selector: (row) => row.profile.inspector_no,
      cell: (row) => row?.profile?.inspector_no
    },
    {
      name: 'Nama',
      selector: (row) => row.fullname,
      cell: (row) => row?.fullname
    },
    {
      name: 'Nomor Telepon',
      selector: (row) => row.phone_number,
      cell: (row) => row?.phone_number
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      cell: (row) => row?.email
    },
    {
      name: 'Bengkel',
      selector: (row) => row.profile.workshop_name,
      cell: (row) => row?.profile?.workshop_name
    }
  ]

  if (isLoading ?? isLoadingHelper) {
    return <Loading visible={true} />
  }

  return (
    <Layout style={{ padding: 32, background: '#F5F5F5', width: '100%' }}>
      <Breadcrumb style={{ margin: 8 }}>
        <Breadcrumb.Item className="font-inter font-semibold text-gray-700">
          Analytics Dashboard
        </Breadcrumb.Item>
        <Breadcrumb.Item
          className="font-inter font-medium text-gray-500 cursor-pointer"
          onClick={() => router.goBack()}>
          Cabang
        </Breadcrumb.Item>
        <Breadcrumb.Item className="font-inter font-medium text-gray-500">
          Total Inspektor
        </Breadcrumb.Item>
      </Breadcrumb>
      <Content style={{ margin: 8 }}>
        <CardContainer minHeight="65%" className={'grid grid-cols-1 gap-5'}>
          <p className="display-xs-semibold text-gray-900 m-0">Daftar Inspektor</p>
          <div className="flex flex-row w-full items-center justify-between">
            <div className="flex flex-row w-full items-center space-x-5">
              <div className="w-1/4">
                <Formik
                  enableReinitialize
                  initialValues={{
                    bengkelSelector: bengkelSelected
                  }}>
                  <FormDropDown
                    isSearch
                    allowClear
                    placeholder="Semua Bengkel"
                    name="bengkelSelector"
                    data={dropDownBengkel}
                    onChange={(value) => {
                      setBengkelSelected(value ?? null)
                      onFilterSearchListInspektor(value ? parseInt(value) : null, inspektorSearch)
                    }}
                  />
                </Formik>
              </div>
            </div>
            <div className="w-1/4">
              <Formik
                initialValues={{
                  searchInspektor: inspektorSearch
                }}>
                <FormInput
                  name="searchInspektor"
                  placeholder="Pencarian"
                  type="text"
                  isIconLeft
                  iconName="search"
                  onValidate={(value) => {
                    setInspektorSearch(value)
                    onFilterSearchListInspektor(bengkelSelected, value)
                  }}
                />
              </Formik>
            </div>
          </div>
          <div className="flex flex-col w-full space-y-5">
            <div className="flex flex-col space-y-5">
              <Table
                currentPage={meta.offset ? meta.offset + 1 : 1}
                totalPerPage={
                  perPageArr.find((item) => item.selected === true).value + (meta.offset ?? 0) >
                  meta.total
                    ? meta.total
                    : perPageArr.find((item) => item.selected === true).value + (meta.offset ?? 0)
                }
                dropDownDataFilter={perPageArr}
                lengthAllData={meta.total}
                columns={columns}
                data={listTotalInspektor}
                onChangePrevPage={() => {
                  if (currentPage > 0) {
                    setCurrentPage(currentPage - 1)
                    onChangePrevNextPage(
                      (currentPage - 1) * perPageArr.find((item) => item.selected === true).value
                    )
                  }
                }}
                onChangeNextPage={() => {
                  if (
                    perPageArr.find((item) => item.selected === true).value + (meta.offset ?? 0) <
                    meta.total
                  ) {
                    setCurrentPage(currentPage + 1)
                    onChangePrevNextPage(
                      (currentPage + 1) * perPageArr.find((item) => item.selected === true).value
                    )
                  }
                }}
                onChangeDropDown={(value) => onChangePerPage(value)}
              />
            </div>
          </div>
        </CardContainer>
      </Content>
    </Layout>
  )
}

export default AnalyticsTotalInspektorPage
